module.exports = "/assets/images/apple_8bba1c.svg";